const chatbot = () => {
  const fullscreen = document.body.classList.contains("assistant");
  ConversaliaWidget.init({
    serviceBaseUrl:
      "https://conversalia-backend-prd.blackbay-f6ad2466.switzerlandnorth.azurecontainerapps.io",
    fullscreen,
    token: "173AB4D2-3F86-4BF1-902D-6EA529889CE5",
  });
};

export default chatbot;
